var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.963,
    height: 18.867,
    viewBox: "0 0 18.963 18.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0055ad;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,49.175a.472.472,0,0,0-.472.472V53.84a1.418,1.418,0,0,1-1.417,1.417H2.361A1.418,1.418,0,0,1,.945,53.84V41.533a1.418,1.418,0,0,1,1.417-1.417H6.555a.472.472,0,1,0,0-.945H2.361A2.364,2.364,0,0,0,0,41.533V53.841A2.364,2.364,0,0,0,2.361,56.2H15.613a2.364,2.364,0,0,0,2.361-2.361V49.647a.472.472,0,0,0-.472-.472Zm0,0",
    transform: "translate(0 -37.334)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M120.868.883a2.125,2.125,0,0,0-3.006,0l-8.426,8.426a.472.472,0,0,0-.121.208l-1.108,4a.472.472,0,0,0,.581.581l4-1.108a.472.472,0,0,0,.208-.121l8.425-8.426a2.128,2.128,0,0,0,0-3.006Zm-10.4,8.733,6.9-6.9,2.224,2.224-6.9,6.9Zm-.444.891,1.777,1.777-2.458.681Zm10.733-6.732-.5.5-2.224-2.224.5-.5a1.181,1.181,0,0,1,1.67,0l.554.554A1.182,1.182,0,0,1,120.754,3.775Zm0,0",
    transform: "translate(-103.081 -0.261)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.b3402be5.svg";
export { ForwardRef as ReactComponent };